var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "org_code_input",
    attrs: {
      "id": "popup_wrap"
    }
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_c('p', [_vm._v("기관코드 입력")]), _c('button', {
    staticClass: "btn_close",
    attrs: {
      "type": "button",
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0)])]), _c('div', {
    staticClass: "popup_content"
  }, [_vm._m(1), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.companyCode,
      expression: "companyCode"
    }],
    staticClass: "popup_select",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.companyCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.sortedCompanyList, function (opt, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": opt.value,
        "selected": index == 0 ? true : false
      }
    }, [_vm._v(" " + _vm._s(opt.text) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type1_big",
    on: {
      "click": _vm.orgCodeUpdate
    }
  }, [_vm._v("입력")])])]), _c('div', {
    staticClass: "main_mask_wrap"
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "box_area clfix"
  }, [_c('div', {
    staticClass: "box_title_popup"
  }, [_vm._v("기관코드"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])]);

}]

export { render, staticRenderFns }